
import AdminPanel from "../components/admin/AdminDashboard";

export default function AdminDashboard() {
  return (
    <div>
      <AdminPanel />
    </div>
  );
}
